import { localeMoment } from '@/util/localeMoment';

export default {
  install(Vue) {
    Vue.prototype.$moment = localeMoment;
  }
};
